export default __webpack_public_path__ + "static/media/voucher2.e4b7acb5.png";